<script>
	import { formatPercent } from '../utils/format.js';
  import { intcomma } from 'journalize';
  import parties from '../utils/parties';



  /** @type {import('../types.d').ReadableRace} */
  export let race;
  

  // $: console.log($race);


  const offices = {
    'M': ['L.A. Mayor', `https://www.latimes.com/projects/2022-california-election-los-angeles-county-live-results/`],
    '0': ['L.A. County Sheriff', `https://www.latimes.com/projects/2022-california-election-los-angeles-county-live-results/`],
    'G': ['Governor', `https://www.latimes.com/projects/2022-california-election-statewide-live-results/`],
    'A': ['Attorney General', `https://www.latimes.com/projects/2022-california-election-statewide-live-results/`],
  };

  $: raceName = offices[$race.office][0];
  $: raceLink = offices[$race.office][1];
	$: totalVotes = $race.total_votes
	$: numOfwinners = $race.number_of_winners
	$: office = $race.office

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }

</script>

<div class="contest">
  <table class="contest__candidates">
    
    <caption class="contest__caption watching-link text-left">
      <a href={raceLink}>
        {raceName}
        <svg class="icon">
          <use xlink:href="#icon-angle-double-right" />
        </svg>
      </a>
    </caption> 
    <thead>
      <tr>
        <th  scope="col" colspan="1" class="contest__candidate-header">
        </th>
        <th scope="col" colspan={1}  class="contest__candidate-header">
          {#if office == "I" }SUPPORT{:else}CANDIDATE{/if}
        </th>
        <th scope="col" class="contest__candidate-header text-left">
          % VOTES
        </th>
        <th scope="col" class="contest__candidate-header">
          TOTAL
        </th>
      </tr>
    </thead>
    <tbody>
      {#each $race.candidates as c, idx}
          <tr class="candidate contest__candidate-row">
            <td class="candidate__cell candidate__cell-bar">
              <div
              class="bar bar-{c.party}"
            >
              {#if c.is_winner == true}
                <div class="candidate__cell-winner"> ✓ </div>
              {/if}
            </div>
            </td>
            <th
              scope="row"
              class="candidate__cell candidate__cell-name"
            >
            {c.given_name} {c.family_name} 
            {#if c.is_incumbent}
            <span
                  class="candidate__cell-incumbent"
                  title="Currently holds this office">*</span
                >
						{/if}
            {#if !["M","0","I"].includes(office) }
            <span class="candidate__cell-name-party">({parties[c.party].abbr})</span>
            {/if}
            </th>
            <td
              class="candidate__cell candidate__cell-pct text-medium text-left">
  						{formatPercent(c.votes, totalVotes, 1)}
  								<span class="candidate__pct-symbol">%</span>
						</td>
            <td
              class="candidate__cell candidate__cell-pct text-medium text-right">
  						{intcomma(c.votes)}
						</td>
          </tr>
      {/each}
    </tbody>
  </table>
</div>
{#if $race.eevp != null}
  <p class="contest__precincts">{$race.eevp}% of expected vote in</p>
{:else}
  <p class="contest__precincts" >{$race.precincts_reporting_percent}% of precincts reporting</p>
{/if}